require('core-js/es6/symbol')
require('core-js/fn/promise')
require('core-js/fn/string/trim')
require('core-js/fn/dom-collections/iterator')
//Require('./libs/css-polyfills.js')
require('custom-event-polyfill')
require('url-polyfill')
require('core-js/fn/object/assign')

const moment = require('moment')

// Moment - isZero
if (moment.fn.isZero === undefined) {
  moment.fn.isZero = function() {
    return this.isSame(moment(0)) || this.isSame(moment(0).startOf('day'))
  }
}

// Array.take
if (Array.prototype.take === undefined) {
  Array.prototype.take = function(count) {
    return this.slice(0, count)
  }
}

// Array.skip
if (Array.prototype.skip === undefined) {
  Array.prototype.skip = function(count) {
    return this.slice(0).splice(count)
  }
}

// Array.clone
if (Array.prototype.clone === undefined) {
  Array.prototype.clone = function() {
    return this.slice(0)
  }
}

// Array.uniq
if (Array.prototype.uniq === undefined) {
  Array.prototype.uniq = function(predicate) {
    return this.filter(function(value, index, self) {
      if (typeof predicate === 'function') {
        return self.findIndex(item => predicate(item) === predicate(value)) === index
      } else {
        return self.indexOf(value) === index
      }
    })
  }
}

// Array.clone
if (Array.prototype.addAll === undefined) {
  Array.prototype.addAll = function(items) {
    items.forEach(item => this.push(item))
    return this
  }
}

// Array.firstOrDefault
if (Array.prototype.firstOrDefault === undefined) {
  Array.prototype.firstOrDefault = function(value = null) {
    return this.nthOrDefault(0, value)
  }
}

// Array.lastOrDefault
if (Array.prototype.lastOrDefault === undefined) {
  Array.prototype.lastOrDefault = function(value = null) {
    return this.nthOrDefault(this.length - 1, value)
  }
}

// Array.nthOrDefault
if (Array.prototype.nthOrDefault === undefined) {
  Array.prototype.nthOrDefault = function(index, value) {
    return this.length === 0 ? value : this[index]
  }
}

// Array.range(from, to)
if (Array.range === undefined) {
  Array.range = function(from, to) {
    return Array.apply(null, { length: (to - from + 1) }).map((item, index) => index + from)
  }
}

// String.contains
if (String.prototype.contains === undefined) {
  String.prototype.contains = function(substring) {
    return this.indexOf(substring) >= 0
  }
}

// String.toNumber
if (String.prototype.toNumber === undefined) {
  String.prototype.toNumber = function({ removeSpaces = true, normalizeDecimalSeparator = true } = {}) {
    let s = this
    if (removeSpaces) s = s.replace(/\s/g, '')
    if (normalizeDecimalSeparator) s = s.replace(/,/g, '.')
    return s.contains('.') ? parseFloat(s) : parseInt(s)
  }
}

// String.compareTo
if (String.prototype.compareTo === undefined) {
  String.prototype.compareTo = String.prototype.localeCompare
}

// Number.compareTo
if (Number.prototype.compareTo === undefined) {
  Number.prototype.compareTo = function(other) {
    if (this < other) return -1
    else if (this > other) return 1
    else return 0
  }
}

// NodeList.map
if (NodeList.prototype.map === undefined) {
  NodeList.prototype.map = Array.prototype.map
}

// HTMLOptionsCollection.map
if (HTMLOptionsCollection.prototype.map === undefined) {
  HTMLOptionsCollection.prototype.map = Array.prototype.map
}

// HTMLOptionsCollection.forEach
if (HTMLOptionsCollection.prototype.forEach === undefined) {
  HTMLOptionsCollection.prototype.forEach = Array.prototype.forEach
}

// IE11 NodeList.forEach
if (typeof NodeList.prototype.forEach !== 'function') {
  NodeList.prototype.forEach = Array.prototype.forEach
}

// NodeList.reduce
if (typeof NodeList.prototype.reduce !== 'function') {
  NodeList.prototype.reduce = Array.prototype.reduce
}

// NodeList.filter
if (typeof NodeList.prototype.filter !== 'function') {
  NodeList.prototype.filter = Array.prototype.filter
}

// NodeList.toArray
if (NodeList.prototype.toArray === undefined) {
  NodeList.prototype.toArray = function() {
    return Array.from(this)
  }
}

// NodeList.firstOrDefault
if (NodeList.prototype.firstOrDefault === undefined) {
  NodeList.prototype.firstOrDefault = Array.prototype.firstOrDefault
}

// NodeList.lastOrDefault
if (NodeList.prototype.lastOrDefault === undefined) {
  NodeList.prototype.lastOrDefault = Array.prototype.lastOrDefault
}

// NodeList.nthOrDefault
if (NodeList.prototype.nthOrDefault === undefined) {
  NodeList.prototype.nthOrDefault = Array.prototype.nthOrDefault
}

// HTMLFormElement.submitWFFM
/**
 * Submits a WFFM form by finding the submit button (required!) and clicking it.
 * All this is needed because someone thought it's best to not have standard
 * handling on a form and added all the processing onto the click event handler
 * instead of submit.
 */
if (HTMLFormElement.prototype.submitWFFM === undefined) {
  HTMLFormElement.prototype.submitWFFM = function() {
    this.querySelector('input[type="submit"]').click()
  }
}

// Element.matches
if (typeof Element.prototype.matches !== 'function') {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.webkitMatchesSelector || function(selector) {
    const element = this
    const elements = (element.document || element.ownerDocument).querySelectorAll(selector)
    let index = 0

    while (elements[index] && elements[index] !== element) {
      ++index
    }

    return Boolean(elements[index])
  }
}

// Element.closest
if (typeof Element.prototype.closest !== 'function') {
  Element.prototype.closest = function(selector) {
    let element = this

    while (element && element.nodeType === 1) {
      if (element.matches(selector)) {
        return element
      }

      element = element.parentNode
    }

    return null
  }
}

// IE11 Object.entries (from https://developer.mozilla.org/pl/docs/Web/JavaScript/Reference/Global_Objects/Object/entries#Polyfill)
if (!Object.entries)
  Object.entries = function(obj){
    const ownProps = Object.keys(obj)
    let i = ownProps.length
    const resArray = new Array(i) // Preallocate the Array
    while (i--)
      resArray[i] = [ ownProps[i], obj[ownProps[i]] ]
    
    return resArray
  }

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
  Object.keys = (function() {
    'use strict'
    const hasOwnProperty = Object.prototype.hasOwnProperty
    const hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString')
    const dontEnums = [
      'toString',
      'toLocaleString',
      'valueOf',
      'hasOwnProperty',
      'isPrototypeOf',
      'propertyIsEnumerable',
      'constructor',
    ]
    const dontEnumsLength = dontEnums.length

    return function(obj) {
      if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
        throw new TypeError('Object.keys called on non-object')
      }

      const result = []
      let prop
      let i

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop)
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i])
          }
        }
      }
      return result
    }
  }())
}



// WEBPACK FOOTER //
// ./src/polyfills.js